import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Icon } from '@iconify/react'
import { Typography, withStyles, Collapse } from '@material-ui/core'
import styles from './styles'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import {
  selectUserLimits,
  selectCurrentCredits,
  selectRefreshesAt,
} from 'src/reducers/user-limits/selector'
import { CoreButton } from '../core'
import UserType from 'src/model/user-types'
import moment from 'moment-timezone'

const CreditBalanceContent = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const userLimits = useSelector(selectUserLimits)
  const currentCredits = useSelector(selectCurrentCredits)
  const refreshesAt = useSelector(selectRefreshesAt)
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const [isOpen, setIsOpen] = useState(false)
  const isNeedToUpgrade =
    !userControl.includes('appsumo') &&
    userControl !== 'Elite' &&
    userControl !== 'Plus' &&
    userControl !== 'Pro v2' &&
    userControl !== 'Launch' &&
    userControl !== 'Essentials' &&
    userControl !== 'Growth' &&
    userControl !== 'Scale' &&
    userControl !== 'Enterprise' &&
    !UserType.isTrialEquivalent(userControl)
  // Fetch user limits if not available
  useEffect(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  return (
    <div className={classes.container}>
      {/* Credit Balance Section */}
      <div className={classes.creditBalanceSection}>
        <div className={classes.creditBalanceHeader}>
          <Icon icon="mage:coin-a" className={classes.creditIcon} />
          <Typography
            style={{
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: 500,
              color: '#015ffb',
            }}
          >
            {currentCredits} Credits
          </Typography>
        </div>
        <Typography variant="body2" color="textSecondary">
          AI credits renew every 30 days.
          {refreshesAt && (
            <span>
              {' '}
              Your renewal date is:{' '}
              {moment(refreshesAt).add('days', 30).format('L')}
            </span>
          )}
        </Typography>
      </div>

      {
        /* Power Up Section */
        isNeedToUpgrade && (
          <div className={classes.sectionBox}>
            <div className={classes.sectionHeader}>
              <Typography className={classes.sectionTitle}>
                ⚡ Power up your creation flow
              </Typography>
              <Typography className={classes.sectionDescription}>
                Get more credits and features by upgrading your plan.
              </Typography>
            </div>
            <CoreButton
              onClick={() => {
                window.location.href = '/pricing'
              }}
            >
              Upgrade
            </CoreButton>
          </div>
        )
      }

      {/* What Can You Build Section */}
      <div className={classes.lastSectionBox}>
        <div className={classes.sectionHeaderWithMargin}>
          <Typography className={classes.sectionTitle}>
            💡 What can you build?
          </Typography>
          <div
            className={classes.seeDetailsContainer}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <Typography className={classes.seeDetailsLink}>
              See details
            </Typography>
            <Icon
              icon="eva:chevron-down-fill"
              className={`${classes.arrowIcon} ${
                isOpen ? classes.arrowIconRotated : ''
              }`}
            />
          </div>
        </div>

        {/* Features Table - Accordion Content */}
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <div className={classes.featuresContainer}>
            {/* Table Header */}
            <div className={classes.tableHeader}>
              <Typography className={classes.tableHeaderText}>
                Feature
              </Typography>
              <Typography className={classes.tableHeaderText}>
                Credit Cost
              </Typography>
            </div>

            {/* Table Rows */}
            <div className={classes.tableRow}>
              <Typography variant="body2" className={classes.featureTitle}>
                AI Course Creator
              </Typography>
              <div className={classes.creditCostDoubleCell}>
                <div className={classes.creditCostCell}>
                  <Icon
                    icon="mage:coin-a"
                    className={classes.creditIconSmall}
                  />
                  <Typography className={classes.creditCostText}>
                    1 credit per AI page
                  </Typography>
                </div>
                <div className={classes.creditCostCell}>
                  <Icon
                    icon="mage:coin-a"
                    className={classes.creditIconSmall}
                  />
                  <Typography className={classes.creditCostText}>
                    1 credit per AI Image
                  </Typography>
                </div>
              </div>
            </div>

            <div className={classes.tableRow}>
              <Typography variant="body2" className={classes.featureTitle}>
                Page Editor AI Assistant
              </Typography>
              <div className={classes.creditCostCell}>
                <Icon icon="mage:coin-a" className={classes.creditIconSmall} />
                <Typography className={classes.creditCostText}>
                  1 credit per content
                </Typography>
              </div>
            </div>

            <div className={classes.tableRow}>
              <Typography variant="body2" className={classes.featureTitle}>
                AI Image Builder
              </Typography>
              <div className={classes.creditCostCell}>
                <Icon icon="mage:coin-a" className={classes.creditIconSmall} />
                <Typography className={classes.creditCostText}>
                  5 credits per image
                </Typography>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default withStyles(styles)(CreditBalanceContent)
